import angular from 'angular';
import uiRouter from 'angular-ui-router';
import homeComponent from './home.component';

let homeModule = angular.module('home', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('home', {
      url: '/',
      component: 'home',
      resolve: {
        $title: () => 'FM Connect - Home'
      }
    });
})

.component('home', homeComponent)

.name;

export default homeModule;



// WEBPACK FOOTER //
// ./client/app/components/home/home.js